import { Injectable } from '@angular/core';
import { WarehouseReceiptStatus } from '../enums/warehouse-receipt-status';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';

@Injectable({
  providedIn: 'root',
})
export class WarehouseReceiptStatusProviderService {
  private entries = new Map<WarehouseReceiptStatus, string>([
    [WarehouseReceiptStatus.Approved, 'Zatwierdzony'],
    [WarehouseReceiptStatus.Draft, 'Szkic'],
  ]);

  public label(status: WarehouseReceiptStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${status}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<WarehouseReceiptStatus>[]> {
    const result = Array.from(this.entries.entries()).map(
      ([status, label]) => new SelectItem(label, status),
    );

    return of(result);
  }
}
